import React from 'react';
import NotificationsSearchResults from './NotificationsSearchResults';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
function NotificationsSearch() {
  return (
    <SearchMenu>
      <FilterConsumer>
        {({ agencies }) => <NotificationsSearchResults filter={agencies} />}
      </FilterConsumer>
    </SearchMenu>
  );
}

export default NotificationsSearch;
